// import React, { useState } from 'react';
// import {
//   LayoutDashboard,
//   MapPin,
//   FolderOpen,
//   UserRound,
//   Users,
//   Building,
//   FileText,
//   Settings,
//   LogOut,
//   ChevronLeft,
//   ChevronRight,
//   Image
// } from 'lucide-react';
// import { MdBusiness, MdList, MdSlideshow } from 'react-icons/md';
// import { SlSpeech } from "react-icons/sl";
// import { MdOutlineNotificationsActive } from "react-icons/md";

// const menuItems = [
//   { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },

// { id: 'department-menu', label: 'Department', icon: <FolderOpen size={20} /> },

// { id: 'employ', label: 'Employee', icon: <Building size={20} /> },


//   { id: 'settings', label: 'Settings', icon: <Settings size={20} /> }
// ];

// const AdminSidebar = ({ activePage, onPageChange }) => {
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [expandedItems, setExpandedItems] = useState(['zone-master']);

//   const toggleExpand = (id) => {
//     setExpandedItems((prev) =>
//       prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
//     );
//   };

//   const handleLogout = () => {
//     if (window.confirm('Do you want to return to the main website?')) {
//       window.location.href = '/admin-login';
//     }
//   };

//   return (
//     <aside
//       style={{
//         width: isCollapsed ? 80 : 260,
//         height: '100vh', // ensure full viewport height
//         display: 'flex',
//         flexDirection: 'column',
//         overflowY: 'auto', // allow scrolling for entire sidebar
//         backgroundColor: '#ffffff',
//         borderRight: '1px solid black',
//         transition: 'width 0.3s'
//       }}
//     >
//       {/* Header */}
//       <div
//         style={{
//           padding: 16,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           borderBottom: '1px solid rgba(74,140,124,0.4)'
//         }}
//       >
//         {!isCollapsed && (
//           <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//             <Building size={24} color="#7f4070" />
//             <span style={{ fontWeight: '600', color: '#7f4070' }}>
//               Admin Panel
//             </span>
//           </div>
//         )}
//         <button
//           onClick={() => setIsCollapsed(!isCollapsed)}
//           style={{
//             padding: 8,
//             background: 'transparent',
//             border: 'none',
//             cursor: 'pointer',
//             borderRadius: 8
//           }}
//         >
//           {isCollapsed ? <ChevronRight /> : <ChevronLeft />}
//         </button>
//       </div>

//       {/* Menu */}
//       <nav style={{ flex: 1, overflowY: 'auto', paddingTop: 8 }}>
//         {menuItems.map((item) => (
//           <div key={item.id}>
//             <button
//               // onClick={() =>
//               //   item.children ? toggleExpand(item.id) : onPageChange(item.id)
//               // }
//               onClick={() => {
//   if (item.children && item.children.length > 0) {
//     toggleExpand(item.id);
//   } else {
//     onPageChange(item.id);
//   }
// }}

//               style={{
//                 width: '100%',
//                 padding: '12px 16px',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 12,
//                 background:
//                   activePage === item.id ? 'rgba(127,64,112,0.2)' : 'transparent',
//                 border: 'none',
//                 cursor: 'pointer',
//                 borderRight:
//                   activePage === item.id
//                     ? '4px solid #7f4070'
//                     : 'none'
//               }}
//             >
//               <span style={{ color: activePage === item.id ? '#7f4070' : '#000' }}>
//                 {item.icon}
//               </span>
//               {!isCollapsed && <span>{item.label}</span>}
//             </button>

//             {/* Sub menu */}
//             {item.children &&
//               !isCollapsed &&
//               expandedItems.includes(item.id) && (
//                 <div style={{ backgroundColor: 'rgba(127,64,112,0.05)' }}>
//                   {item.children.map((child) => (
//                     <button
//                       key={child.id}
//                       onClick={() => onPageChange(child.id)}
//                       style={{
//                         width: '100%',
//                         padding: '8px 48px',
//                         textAlign: 'left',
//                         background:
//                           activePage === child.id
//                             ? 'rgba(127,64,112,0.2)'
//                             : 'transparent',
//                         border: 'none',
//                         cursor: 'pointer',
//                         color:
//                           activePage === child.id ? '#7f4070' : '#000'
//                       }}
//                     >
//                       {child.label}
//                     </button>
//                   ))}
//                 </div>
//               )}
//           </div>
//         ))}
//       </nav>

//       {/* Logout */}
//       <button
//         onClick={handleLogout}
//         style={{
//           padding: '12px 16px',
//           display: 'flex',
//           alignItems: 'center',
//           gap: 12,
//           borderTop: '1px solid rgba(74,140,124,0.4)',
//           background: 'transparent',
//           cursor: 'pointer'
//         }}
//       >
//         <LogOut size={20} color="red" />
//         {!isCollapsed && <span>Logout</span>}
//       </button>
//     </aside>
//   );
// };

// export default AdminSidebar;


import React, { useState } from 'react';
import {
  LayoutDashboard,
  FolderOpen,
  Settings,
  LogOut,
  ChevronLeft,
  ChevronRight,
  Building,
  Users,
} from 'lucide-react';
import { colors } from '../utils/theme';

const menuItems = [
  { id: 'dashboard', label: 'Dashboard', icon: <LayoutDashboard size={20} /> },
  { id: 'department-menu', label: 'Department', icon: <FolderOpen size={20} /> },
  { id: 'employ', label: 'Employee', icon: <Users size={20} /> },
  {id:'Devices' , label:'Devices' ,icon: <Users size={20} /> },
    {id:'Sessions' , label:'Sessions' ,icon: <Users size={20} /> },
     {id:'Employees Tracker' , label:'Employees Tracker' ,icon: <Users size={20} /> },
  
  // { id: 'settings', label: 'Settings', icon: <Settings size={20} /> }
];

const AdminSidebar = ({ activePage, onPageChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleLogout = () => {
    if (window.confirm('Confirm Logout: Return to the authentication portal?')) {
      window.location.href = '/admin-login';
    }
  };

  return (
    <aside
      style={{
        width: isCollapsed ? 80 : 260,
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: colors.card,
        boxShadow: '4px 0 24px rgba(0,0,0,0.02)',
        borderRight: `1px solid rgba(0,0,0,0.05)`,
        transition: 'width 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 100,
      }}
    >
      {/* Header / Brand */}
      <div
        style={{
          height: 80,
          display: 'flex',
          alignItems: 'center',
          padding: '0 24px',
          justifyContent: isCollapsed ? 'center' : 'space-between',
        }}
      >
        {!isCollapsed && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
                backgroundColor: colors.primary,
                padding: 8,
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <Building size={20} color="#fff" />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: '800', color: colors.text, fontSize: 18, letterSpacing: -0.5 }}>
                   <span style={{ color: colors.primary }}>ADMIN</span>
                </span>
                <span style={{ fontSize: 10, color: '#999', textTransform: 'uppercase', letterSpacing: 1 }}>
                  Management
                </span>
            </div>
          </div>
        )}
        
        {/* Toggle Button */}
        <button
          onClick={() => setIsCollapsed(!isCollapsed)}
          style={{
            width: 32,
            height: 32,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: isCollapsed ? colors.primary + '15' : '#f8f8f8',
            border: 'none',
            borderRadius: 10,
            cursor: 'pointer',
            color: isCollapsed ? colors.primary : '#666',
            transition: '0.3s'
          }}
        >
          {isCollapsed ? <ChevronRight size={18} /> : <ChevronLeft size={18} />}
        </button>
      </div>

      {/* Navigation Menu */}
      <nav style={{ flex: 1, padding: '16px 12px', marginTop: 10 }}>
        {menuItems.map((item) => {
          const isActive = activePage === item.id;
          const isHovered = hoveredItem === item.id;

          return (
            <div key={item.id} style={{ marginBottom: 6 }}>
              <button
                onMouseEnter={() => setHoveredItem(item.id)}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => onPageChange(item.id)}
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: isCollapsed ? 0 : 14,
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  backgroundColor: isActive ? colors.primary : (isHovered ? colors.background : 'transparent'),
                  border: 'none',
                  borderRadius: 14,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  boxShadow: isActive ? `0 8px 16px ${colors.primary}40` : 'none',
                }}
              >
                <div style={{
                  color: isActive ? '#fff' : (isHovered ? colors.primary : '#666'),
                  transition: '0.3s',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  {item.icon}
                </div>

                {!isCollapsed && (
                  <span style={{
                    color: isActive ? '#fff' : (isHovered ? colors.text : '#666'),
                    fontWeight: isActive ? '600' : '500',
                    fontSize: 15,
                    transition: '0.3s'
                  }}>
                    {item.label}
                  </span>
                )}
                
                {/* Active Indicator Pillar */}
                {isActive && !isCollapsed && (
                    <div style={{
                        position: 'absolute',
                        right: 12,
                        width: 6,
                        height: 6,
                        borderRadius: '50%',
                        backgroundColor: '#fff'
                    }} />
                )}
              </button>
            </div>
          );
        })}
      </nav>

      {/* Footer / Logout */}
      <div style={{ padding: 16 }}>
        <button
          onClick={handleLogout}
          style={{
            width: '100%',
            padding: '14px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            gap: 14,
            backgroundColor: colors.primary + '10',
            border: 'none',
            borderRadius: 16,
            cursor: 'pointer',
            color: colors.primary,
            transition: 'all 0.3s ease',
            fontWeight: '600'
          }}
        >
          <LogOut size={20} />
          {!isCollapsed && <span>Logout Portal</span>}
        </button>
        
        {!isCollapsed && (
            <p style={{ 
                textAlign: 'center', 
                fontSize: 10, 
                color: '#BBB', 
                marginTop: 16,
                textTransform: 'uppercase',
                letterSpacing: 1
            }}>
                v1.0.4 Premium
            </p>
        )}
      </div>
    </aside>
  );
};

export default AdminSidebar;